module.exports = __webpack_public_path__ + "img/youlose.137fc3a1.jpg";